import React from 'react'
import { useContext, useState } from 'react'
import { CandidatesContext } from '../../../utils/context'
import { useDispatch } from 'react-redux'
import styles from './styles.module.scss'
import Button from '../../../components/Button'
import { Input } from '../../../components/ModalInputs'
import Table from '../../../components/Table'
import { addCandidateScheduleTest } from '../../../actions/candidates'
import Confirmation from '../../../components/Confirmation/Confirmation'


export default function Schedule() {

  const { candidateId, closeModal } = useContext(CandidatesContext)
  const dispatch = useDispatch()
  const [scheduleData, setScheduleData] = useState([])
  const [selectedRow, setSelectedRow] = useState(null)
  const [addMode, setAddMode] = useState(false)
  const [newRow, setNewRow] = useState({ exam_date: '', slot: '', exam_board: '', ticket: '', code: '', actual_start_time: '' })
  const [confirmation, setConfirmation] = useState(false)

  const selectedItem = scheduleData.find(r => r.id === selectedRow) || null

  const handleAdd = async () => {
    if (!newRow.exam_date) return
    const ok = await dispatch(addCandidateScheduleTest(candidateId, newRow))
    if (ok) {
      setScheduleData(prev => [...prev, { ...newRow, id: Date.now() }])
      setAddMode(false)
      setNewRow({ exam_date: '', slot: '', exam_board: '', ticket: '', code: '', actual_start_time: '' })
    }
  }

  const handleDeleteConfirm = () => {
    if (!selectedRow) return
    setConfirmation(true)
  }

  const acceptDelete = () => {
    setScheduleData(prev => prev.filter(row => row.id !== selectedRow))
    setSelectedRow(null)
    setConfirmation(false)
  }

  return (
    <>
      {confirmation && (
        <Confirmation
          title='Удалить запись?'
          acceptConfirmation={acceptDelete}
          rejectConfirmation={() => setConfirmation(false)}
        />
      )}
      <div className={styles.modalMain}>
        <div className={styles.tabWrapper}>
          <Table>
            <thead>
              <tr>
                <th>Дата</th>
                <th>Время</th>
                <th>Комиссия</th>
                <th>Билет</th>
                <th>Код</th>
                <th>Время начала (факт)</th>
              </tr>
            </thead>
            <tbody>
              {scheduleData.map((row) => (
                <tr
                  key={row.id}
                  onClick={() => setSelectedRow(row.id)}
                  className={selectedRow === row.id ? styles.selectedRow : ''}
                >
                  <td>{row.exam_date}</td>
                  <td>{row.slot}</td>
                  <td>{row.exam_board}</td>
                  <td>{row.ticket}</td>
                  <td>{row.code}</td>
                  <td>{row.actual_start_time}</td>
                </tr>
              ))}
              {scheduleData.length === 0 && (
                <tr>
                  <td colSpan={6} style={{ textAlign: 'center', color: '#999' }}>Нет данных</td>
                </tr>
              )}
            </tbody>
          </Table>

          {addMode && (
            <>
              <div className={styles.inputsRow} style={{ marginTop: '0.75rem', alignItems: 'flex-end' }}>
                <Input
                  label='Дата'
                  type='date'
                  value={newRow.exam_date}
                  onChange={e => setNewRow(v => ({ ...v, exam_date: e.target.value }))}
                />
                <Input
                  label='Время'
                  value={newRow.slot}
                  onChange={e => setNewRow(v => ({ ...v, slot: e.target.value }))}
                />
                <Input
                  label='Комиссия'
                  value={newRow.exam_board}
                  onChange={e => setNewRow(v => ({ ...v, exam_board: e.target.value }))}
                />
                <Input
                  label='Билет'
                  value={newRow.ticket}
                  onChange={e => setNewRow(v => ({ ...v, ticket: e.target.value }))}
                />
                <Input
                  label='Код'
                  value={newRow.code}
                  onChange={e => setNewRow(v => ({ ...v, code: e.target.value }))}
                />
                <Input
                  label='Время начала (факт)'
                  value={newRow.actual_start_time}
                  onChange={e => setNewRow(v => ({ ...v, actual_start_time: e.target.value }))}
                />
              </div>
              <div className={styles.scheduleButtons}>
                <Button mode='bordered' onClick={handleAdd}>Сохранить</Button>
                <Button mode='bordered' onClick={() => setAddMode(false)}>Отмена</Button>
              </div>
            </>
          )}

          {!addMode && (
            <div className={styles.scheduleButtons} style={{ marginTop: '0.75rem' }}>
              <Button mode='bordered' onClick={() => setAddMode(true)}>Добавить</Button>
              <Button mode='bordered' onClick={handleDeleteConfirm} disabled={!selectedRow}>Удалить</Button>
              <Button
                mode='bordered'
                disabled={!selectedItem?.tasks_url}
                onClick={() => window.open(selectedItem?.tasks_url, '_blank')}
              >Просмотр заданий</Button>
            </div>
          )}

          {selectedItem && (
            <div className={styles.inputsRow} style={{ marginTop: '1rem' }}>
              <Input
                label='Одноразовый пароль'
                value={selectedItem.otp || ''}
                onChange={e => setScheduleData(prev =>
                  prev.map(r => r.id === selectedRow ? { ...r, otp: e.target.value } : r)
                )}
                style={{ width: '200px' }}
              />
            </div>
          )}
        </div>
      </div>
      <div className={styles.modalFooter}>
        <div />
        <Button mode='white' onClick={closeModal}>Закрыть</Button>
      </div>
    </>
  )
}
